export const normal = "400"
export const bold = "600"
